module.exports = __webpack_public_path__ + "img/gift3.57006b4d.png";